import { render, staticRenderFns } from "./DesignDesignerForm.vue?vue&type=template&id=08ea2183&"
import script from "./DesignDesignerForm.vue?vue&type=script&lang=js&"
export * from "./DesignDesignerForm.vue?vue&type=script&lang=js&"
import style0 from "./DesignDesignerForm.vue?vue&type=style&index=0&id=08ea2183&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports